(function () {
  'use strict';

  var CARATOS_BASE = 'https://caratapp.co';
  var WHATSAPP_NUMBER = '919220822217';
  var MAX_DIMENSION = 1600;
  var JPEG_QUALITY = 0.82;

  function compressImage(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onerror = reject;
      reader.onload = function () {
        var img = new Image();
        img.onerror = reject;
        img.onload = function () {
          var scale = Math.min(1, MAX_DIMENSION / Math.max(img.width, img.height));
          var w = Math.round(img.width * scale);
          var h = Math.round(img.height * scale);
          var canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, w, h);
          resolve(canvas.toDataURL('image/jpeg', JPEG_QUALITY));
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    });
  }

  function initForm(form) {
    var fileInput = form.querySelector('[data-rc-bespoke-file]');
    var fileLabelText = form.querySelector('[data-rc-bespoke-file-text]');
    var submitBtn = form.querySelector('[data-rc-bespoke-submit]');
    var submitText = form.querySelector('[data-rc-bespoke-submit-text]');
    var errorEl = form.querySelector('[data-rc-bespoke-error]');
    var defaultFileText = fileLabelText ? fileLabelText.textContent : '';
    var defaultSubmitText = submitText ? submitText.textContent : '';

    if (fileInput && fileLabelText) {
      fileInput.addEventListener('change', function () {
        if (fileInput.files && fileInput.files.length > 0) {
          fileLabelText.textContent = fileInput.files[0].name;
        } else {
          fileLabelText.textContent = defaultFileText;
        }
      });
    }

    function setError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      setError('');

      var name = form.querySelector('[name="customerName"]');
      var phone = form.querySelector('[name="phone"]');
      var email = form.querySelector('[name="email"]');
      var material = form.querySelector('[name="material"]');
      var message = form.querySelector('[name="message"]');
      var honeypot = form.querySelector('[name="website"]');

      if (!name.value.trim() || !phone.value.trim()) {
        setError('Please share your name and a phone or WhatsApp number.');
        return;
      }

      submitBtn.disabled = true;
      if (submitText) submitText.textContent = 'Sending your details…';

      // Open the tab synchronously, inside the click handler, before any
      // await/.then() — that's what keeps it tied to the user's actual
      // gesture. Opening it later (after the fetch resolves, as this used
      // to) reads as an unsolicited popup to most browsers' popup blockers
      // and gets silently dropped, even though the click genuinely
      // initiated it. This tab is navigated to the real wa.me link once we
      // know it; if anything fails first, it's closed instead of left
      // stuck on about:blank.
      var waTab = window.open('', '_blank');

      var payload = {
        customerName: name.value.trim(),
        phone: phone.value.trim(),
        email: email ? email.value.trim() : '',
        material: material ? material.value : '',
        message: message ? message.value.trim() : '',
        website: honeypot ? honeypot.value : '',
      };

      var hasFile = fileInput && fileInput.files && fileInput.files.length > 0;
      var imagePromise = hasFile ? compressImage(fileInput.files[0]) : Promise.resolve(null);

      imagePromise
        .then(function (imageDataUrl) {
          if (imageDataUrl) payload.imageDataUrl = imageDataUrl;
          return fetch(CARATOS_BASE + '/api/bespoke-inquiry', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
        })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.error || 'Something went wrong.');
            return data;
          });
        })
        .then(function (data) {
          var lines = [
            'Hi RareCut! I would love a consultation for a bespoke piece.',
            'Name: ' + payload.customerName,
            payload.material ? 'Material: ' + payload.material : '',
            payload.message ? 'Details: ' + payload.message : '',
            data.imageUrl ? 'Reference image: ' + CARATOS_BASE + data.imageUrl : '',
          ].filter(Boolean);
          var text = encodeURIComponent(lines.join('\n'));
          var waUrl = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + text;
          if (waTab && !waTab.closed) {
            waTab.location.href = waUrl;
          } else {
            // Popup was blocked despite the synchronous open (rare, but
            // possible with aggressive blockers) — fall back to navigating
            // the current tab so the request is never silently lost.
            window.location.href = waUrl;
          }
          if (submitText) submitText.textContent = 'Sent — check WhatsApp';
        })
        .catch(function (err) {
          if (waTab && !waTab.closed) waTab.close();
          setError(err.message || 'Something went wrong. Please try again.');
          submitBtn.disabled = false;
          if (submitText) submitText.textContent = defaultSubmitText;
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-rc-bespoke-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
